export class BookingStatusNotAuthorizedError extends Error {
  constructor(message = 'Booking status not authorized') {
    super(message);
    this.name = 'BookingStatusNotAuthorizedError';
  }
}
